"use client";

import Cart from "@/common/constants/cart";
import LinkElement from "@/components/LinkElement";
import Popup from "@/components/Popup";
import Skeleton from "@/components/Skeleton";
import Button from "@/components/ui/Button";
import Money from "@/components/ui/Money";
import { getListProductRelated } from "@/lib/api/shop/products";
import useStoreId from "@/lib/hooks/useStoreId";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import useWindowSize from "@/lib/hooks/useWindowSize";
import { setRecentProduct } from "@/redux/features/CartSlice";
import { setPopupId } from "@/redux/features/ShopSlice";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { ProductJson } from "@/types/Product.type";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import SkeletonList from "~components/card/children/SkeletonList";
import CollectionList from "~components/collection/children/CollectionList";

const AddCartPopup = () => {
	const translate = {
		addcart_title: "addcart_title",
		addcart_desc1: "addcart_desc1",
		sum_short: "sum_short",
		countinue_shopping: "countinue_shopping",
		addcartfooter_title: "addcartfooter_title",
		pay: "pay",
		product: "product",
		go_to_cart: "go_to_cart",
	};
	const { t } = useTranslationApi(Object.values(translate));
	const router = useRouter();
	const dispatch = useAppDispatch();
	const { width = 0 } = useWindowSize();
	const device = useAppSelector((state) => state.ShopReducer.device);
	//states
	const popupId = useAppSelector((state) => state.ShopReducer.popupId);
	const { data: store_id } = useStoreId();

	const recentProductAddToCart = useAppSelector(
		(state) => state.CartReducer.recentProductAddToCart
	);

	const firstProductAdd = recentProductAddToCart?.[0];
	// const productRecenAdd
	const [data, setData] = useState<ProductJson[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

	//fetch data
	const fetchProductList = async () => {
		if (recentProductAddToCart.length > 0) {
			setLoading(true);
			try {
				const collection = await getListProductRelated(firstProductAdd.id, {
					page: 1,
					store_id: store_id,
					collection_id: firstProductAdd.collections
						.map((col) => col.handle)
						.join(","),
					brand: firstProductAdd.brand?.handle,
					limit: 20,
				});

				setData(collection.data.items);
			} catch (error) {
			} finally {
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		if (popupId === Cart.POPUP.add_cart_popup) {
			fetchProductList();
		}
	}, [popupId]);

	useEffect(() => {
		if (popupId === "") {
			setLoadingBtn(false);
		}
	}, [popupId]);

	return (
		<>
			{device === "desktop" ? (
				<div className=" hidden md:block w-full">
					<Popup
						classNameContent={`${width < 768 ? "w-full " : "w-fit "
							} p-0 overflow-hidden`}
						isDrawerMobile
						popupId={Cart.POPUP.add_cart_popup}
						handleOnClose={() => {
							dispatch(setPopupId(""));
							dispatch(setRecentProduct([]));
						}}
						classNameTransitionContent="modal-wishlist">
						<div className="bg-white w-full md:min-w-[720px] lg:min-w-[810px] md:max-w-[720px] lg:max-w-[810px]">
							<div className="min-h-[48px] text-gray-500 border-b border-b-gray-300 text-center font-medium text-h5 flex items-center justify-center">
								<p className="w-full p-4 text-lg leading-[1.6] top-auto translate-">
									{t(translate.addcart_title)}
								</p>
							</div>
							{/* {recentProductAddToCart.length > 0 &&
            recentProductAddToCart[0].id > 0 && (
              <div className="px-4 py-2 flex items-center md:items-start justify-center gap-4 border-b border-gray-200">
                <Image
                  height={100}
                  width={100}
                  src={
                    recentProductAddToCart[0]?.images.length > 0
                      ? recentProductAddToCart[0]?.images[0].url
                      : ""
                  }
                  alt={"image"}
                  className="w-[100px] h-[100px] object-contain"
                />

                <div className="text-sm text-gray-500 flex flex-col gap-[2px] max-w-[370px]">
                  {recentProductAddToCart[0]?.tags.length > 0 && (
                    <ProductTags
                      tags={recentProductAddToCart[0].tags}
                      className="mb-[2px]"
                    />
                  )}
                  <h4 className="text-sm font-bold line-clamp-1">
                    {recentProductAddToCart[0]?.name}
                  </h4>
                  {recentProductAddToCart[0]?.brand && (
                    <p className="line-clamp-1">
                      Thương hiệu:{" "}
                      <b>{recentProductAddToCart[0]?.brand?.title}</b>
                    </p>
                  )}

                  <div className="flex items-end justify-between">
                    <ProductSinglePrice
                      productVariant={recentProductAddToCart[0]}
                      className="gap-0"
                    />
                  </div>
                </div>
              </div>
            )} */}
							<div className="flex flex-col gap-4 text-center px-4 pt-4 pb-6 md:border-b border-b-gray-300">
								<p className="text-sm">
									<span className="font-bold">Freeship</span>{" "}
									{t(translate.addcart_desc1)}
								</p>
								<p className="text-sm">
									<span className="font-bold">{t("sum_short")}</span> (
									{firstProductAdd &&
										firstProductAdd.quantity}{" "}
									{t(translate.product)}):{" "}
									<span className="font-bold">
										{firstProductAdd && (
											<Money
												value={
													firstProductAdd?.pricePreview?.price_final || firstProductAdd.price
												}
											/>
										)}
									</span>
								</p>
								<div className="flex justify-center items-center gap-3">
									<Button
										loading={loadingBtn}
										disabled={loadingBtn}
										label={t(translate.go_to_cart)}
										mode="main"
										className="w-[158px] h-[34px] text-sm flex items-center justify-center"
										onClick={() => {
											// dispatch(setRecentProduct([]));
											setLoadingBtn(true);
											router.push("/cart");
										}}
									/>

									<Button
										label={t(translate.countinue_shopping)}
										mode="light"
										className="w-[158px] h-[34px] text-sm flex items-center justify-center"
										onClick={() => {
											dispatch(setRecentProduct([]));
											dispatch(setPopupId(""));
										}}
									/>
								</div>
							</div>

							{loading ? (
								width > 768 ? (
									<div className="mt-4">
										<Skeleton className="mx-auto h-[10px] rounded-md mb-4"></Skeleton>
										<div className="md:grid grid-cols-4 gap-[20px] px-[15px] h-[300px]">
											<SkeletonList number={4} />
										</div>
									</div>
								) : (
									<>
										<div className="flex justify-between px-[15px] mt-2">
											<SkeletonList number={2} />
										</div>
									</>
								)
							) : (
								<>
									{data.length > 0 && (
										<div className="w-full md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl mx-auto my-6">
											<h5 className="text-center text-lg text-gray-500 leading-[1.6] mb-4 font-bold md:font-normal">
												{t(translate.addcartfooter_title)}
											</h5>
											<div className="w-full">
												<CollectionList
													isAnimate={false}
													data={data}
													isAddCartPopup={true}
													navigation={false}
												/>
											</div>
										</div>
									)}
								</>
							)}
						</div>
					</Popup>
				</div>
			) : (
				<div className=" block  md:hidden w-full">
					<Popup
						classNameContent={` p-0 overflow-hidden`}
						popupId={Cart.POPUP.add_cart_popup}
						handleOnClose={() => {
							dispatch(setPopupId(""));
							dispatch(setRecentProduct([]));
						}}
						classNameTransitionContent="modal-wishlist"
						animate="tran-up">
						{firstProductAdd ? (
							<div className="bg-white w-full md:min-w-[720px] lg:min-w-[810px] md:max-w-[720px] lg:max-w-[810px] min-h-[350px] flex flex-col">
								<div className="min-h-[48px] text-gray-500  text-center font-medium text-h5 flex items-center justify-center">
									<p className="w-full p-4 text-lg leading-[1.6] top-auto translate-">
										{t(translate.addcart_title)}
									</p>
								</div>

								<div className="flex flex-col gap-6 text-center px-4 pt-4 pb-[95px]  flex-1">
									<ul className=" flex flex-col gap-[13px]">
										{firstProductAdd.brand ? (
											<li className=" flex   ">
												<span className="min-w-[130px] max-w-[130px]  text-start  text-sm font-semibold">
													Thương hiệu
												</span>
												<LinkElement
													href={`/blogs/thuong-hieu-nuoc-hoa/${firstProductAdd.brand.handle}`}
													className="  text-sm ">
													{firstProductAdd.brand.title}
												</LinkElement>
											</li>
										) : null}

										<li className=" flex w-full  ">
											<span className=" min-w-[130px] max-w-[130px]  text-start text-sm font-semibold">
												Sản phẩm
											</span>
											<span className=" text-start  text-sm line-clamp-2">
												<LinkElement
													href={`/products/${firstProductAdd.handle}`}
													className="  text-sm ">
													{firstProductAdd.name}
												</LinkElement>
											</span>
										</li>
										<li className=" flex w-full  ">
											<span className=" min-w-[130px] max-w-[130px]  text-start text-sm font-semibold">
												Size
											</span>
											<span className=" text-start text-sm ">
												{firstProductAdd.option_name}
											</span>
										</li>
										<li className=" flex w-full  ">
											<span className="min-w-[130px] max-w-[130px]  text-start  text-sm font-semibold">
												Số lượng
											</span>
											<span className="  text-sm ">
												{firstProductAdd.quantity}
											</span>
										</li>
										<li className=" flex w-full  ">
											<span className=" min-w-[130px] max-w-[130px]  text-start text-sm font-semibold">
												Giá
											</span>
											<span className="  text-sm ">
												<Money
													className=" font-bold"
													value={
														firstProductAdd?.pricePreview?.price_final ||
														firstProductAdd.price
													}
												/>
											</span>
										</li>
									</ul>
									<div className="flex  justify-between items-center gap-4">
										<Button
											label={t(translate.countinue_shopping)}
											mode="light"
											className="w-full flex-1 h-[34px] text-sm flex items-center justify-center"
											onClick={() => {
												dispatch(setRecentProduct([]));
												dispatch(setPopupId(""));
											}}
										/>
										<Button
											loading={loadingBtn}
											disabled={loadingBtn}
											label={t(translate.go_to_cart)}
											mode="main"
											className="w-full flex-1 h-[34px] text-sm flex items-center justify-center"
											onClick={() => {
												// dispatch(setRecentProduct([]));
												setLoadingBtn(true);
												router.push("/cart");
											}}
										/>
									</div>
								</div>
							</div>
						) : null}
					</Popup>
				</div>
			)}
		</>
	);
};

export default AddCartPopup;
